import axios from "axios";
import store from "@/store";
import { Toast } from "vant";

const instance = axios.create({
    timeout: 30 * 1000,
    baseURL: "/api",
});

const settings = {
    showToast: false,
};

instance.interceptors.request.use(undefined, (err) => {
    console.error("request-error", err);
});

instance.interceptors.response.use(
    (res) => {
        if (res.data.code !== 200 && res.data.code !== 1000) {
            if (settings.showToast) {
                Toast(res.data.msg);
            }
            return Promise.reject(res.data);
        }
        return res.data;
    },
    (err) => {
        if (axios.isCancel(err)) {
            return Promise.reject({
                code: 10000,
                msg: "Cancel",
                data: null,
            });
        }
        if (err.code === "ECONNABORTED") {
            return Promise.reject({
                code: 10001,
                msg: "超时",
                data: null,
            });
        }
        console.error("response-error", err.toJSON());
        return Promise.reject(err);
    },
);

export function request(config) {
    let cancel = "";
    let token = store.state.token;
    if (config.settings?.showToast) {
        settings.showToast = true;
    } else {
        settings.showToast = false;
    }

    let newConfig = {
        ...config,
        headers: {
            Authorization: token,
        },
    };

    return {
        instance: instance({
            ...newConfig,
            cancelToken: new axios.CancelToken((c) => {
                cancel = c;
            }),
        }),
        cancel,
    };
}
